import { Alert, AlertTitle, Button, Box, Typography } from '@mui/material';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

/** Awaria renderowania nie może zostawić operatora z białym ekranem bez informacji. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('[control-center] błąd renderowania', error, info.componentStack);
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="error" role="alert">
          <AlertTitle>Aplikacja napotkała błąd</AlertTitle>
          <Typography variant="body2" sx={{ mb: 2 }}>
            {this.state.error.message}
          </Typography>
          <Button size="small" variant="outlined" onClick={() => this.setState({ error: null })}>
            Spróbuj ponownie
          </Button>
        </Alert>
      </Box>
    );
  }
}
